<template>
  <v-app>
    <Navigation v-if="viewLayout"></Navigation>
    <router-view v-else />
  </v-app>
</template>

<script>
import Navigation from "@/components/Navigation.vue";

export default {
  name: "App",

  data: () => ({}),
  computed: {
    viewLayout() {
      if (this.$route.name === "Login") return false;
      if(this.$route.name === "GetStarted") return false;
      return true;
    },
  },

  components: {
    Navigation,
  },
};
</script>
<style>
html, body {
  overflow: hidden;
  background: #f8f9fb;
}
#app {
  background: #f8f9fb;
}
.v-application,
.v-application__wrap {
  background: transparent !important;
}
::-webkit-scrollbar {
  width: 6px;
  background: #f0f2f5;
}
::-webkit-scrollbar-thumb {
  background: rgba(10, 22, 40, 0.15);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(10, 22, 40, 0.25);
}
body {
  font-family: "Inter", sans-serif;
}
</style>
